module.exports = __webpack_public_path__ + "assets/img/bg-male-7aefd5f9.png";